import PropTypes from 'prop-types';
import { paramPropType } from '../../../shared/customReports/propTypes';

export const paramsPropTypes = PropTypes.objectOf(paramPropType.isRequired);
